import { MenuFavoriteResponseDTO, MenuFavoritesDTO, MenuFavoritesResponseDTO } from "@dto/menuFavorites.dto";
import axios from "axios";
import { API_URL } from "src/data/Api";
import { postApi } from "src/util/apiCalls";

export const getMenuFavorites = async () => {
  const response = await axios.get<MenuFavoritesResponseDTO>(API_URL.MENU + '/favorites/summary');
  return response.data;
}

export const addOrDeleteMenuFavorite = async (mf: MenuFavoritesDTO) => {
  return await postApi<MenuFavoriteResponseDTO, MenuFavoritesDTO>(API_URL.MENU + '/favorites/summary', mf)
}